import React from 'react';
import { Link } from 'react-router-dom';
import { Cards } from '@phosphor-icons/react';

function TopGNB() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 flex justify-center items-center gap-2 py-4 bg-white/70 backdrop-blur-md border-b border-white/20 shadow-sm">
      <Cards size={24} weight="duotone" className="text-primary" />
      <Link to="/" className="font-bold text-xl text-primary tracking-tight">VIVA FLIP</Link>
    </nav>
  );
}

export default TopGNB;